import { useCallback } from "react";
import { graphql, useMutation } from "react-relay/hooks";

import type { uploadFlightLogsMutation } from "__generated__/uploadFlightLogsMutation.graphql";

export const FlightLogUploadMutation = graphql`
  mutation uploadFlightLogsMutation($deviceNodeId: ID!, $flightId: String!) {
    requestFlightLogUpload(deviceNodeId: $deviceNodeId, flightId: $flightId) {
      errors
      vehicle {
        id
        flightLogsToUpload
      }
    }
  }
`;

export const useFlightLogUpload = (
  onCompleted?: (response: uploadFlightLogsMutation["response"]) => void
) => {
  const [flightLogUpload] = useMutation<uploadFlightLogsMutation>(FlightLogUploadMutation);

  return useCallback(
    (deviceNodeId: string, flightId: string) => {
      flightLogUpload({
        variables: { deviceNodeId, flightId },
        onCompleted,
      });
    },
    [flightLogUpload, onCompleted]
  );
};
